import { cn } from '@/shared/lib/utils'

import type { CardVariant } from './theme-tokens'

const variantGradient: Record<CardVariant, string> = {
  default: 'bg-gradient-to-t from-[#E4E8FA] to-[#E0DBFD]',
  purple: 'bg-gradient-to-t from-[#E8D4F4] to-[#DEC8F0]',
  yellow: 'bg-gradient-to-t from-[#F5ECD4] to-[#F0DFBA]',
  lightBlue: 'bg-gradient-to-t from-[#D4E8F7] to-[#C8E0F4]',
  gray: 'bg-card',
  dark: 'bg-[#292943]'
}

interface BoxProps {
  children: React.ReactNode
  className?: string
  variant?: CardVariant
}

export const Box = ({ children, className, variant = 'default' }: BoxProps) => {
  return (
    <div className={cn(variantGradient[variant], 'p-3 rounded-lg', className)}>
      {children}
    </div>
  )
}
